import React from "react";

import { Typography } from "@/components/Typography";
import { Form } from "@/components/Form";

import { FormFieldProps } from "@/components/Form/types";

interface PasswordFormViewProps {
  title: string;
  formFields: FormFieldProps[];
  onSubmit: (values: any, methods: any) => void;
  schema: any;
  isLoading: boolean;
  isDisabled?: boolean;
  onWatchFields?: (params: { field: string; value: string }) => void;
}

export const PasswordFormView = ({
  title,
  formFields,
  onSubmit,
  schema,
  isLoading,
  isDisabled = false,
  onWatchFields,
}: PasswordFormViewProps) => (
  <>
    <Typography
      Tag="p"
      classname="recover-password__title NewPassword__title"
      size="xl"
      spacing={5}
    >
      {title}
    </Typography>

    <Form
      fields={formFields}
      onSubmit={onSubmit}
      schema={schema}
      validationMode="onSubmit"
      className="u-spacing-5"
      isLoading={isLoading}
      isDisabled={isDisabled}
      onWatchFields={onWatchFields}
    />
  </>
);
